import {
  FETCH_ALERTS_BEGIN,
  FETCH_ALERTS_SUCCESS,
  FETCH_ALERTS_FAILURE,
  FETCH_ALERTS_DISMISS_ERROR,
} from './constants';
import { serviceFind } from '../../../common/feathers'
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useCallback } from 'react';

export const fetchAlerts = serviceFind('alerts', {
  begin: FETCH_ALERTS_BEGIN,
  success: FETCH_ALERTS_SUCCESS,
  fail: FETCH_ALERTS_FAILURE
})

export function useFetchAlerts() {
  const dispatch = useDispatch();

  const { fetchAlertsPending, fetchAlertsError, alerts } = useSelector(
    state => ({
      fetchAlertsPending: state.alert.fetchAlertsPending,
      fetchAlertsError: state.alert.fetchAlertsError,
      alerts: state.alert.alerts,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchAlerts(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchAlertsError());
  }, [dispatch]);

  return {
    fetchAlerts: boundAction,
    fetchAlertsPending,
    fetchAlertsError,
    alerts,
    dismissFetchAlertsError: boundDismissError,
  };
}

export function dismissFetchAlertsError() {
  return {
    type: FETCH_ALERTS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FETCH_ALERTS_BEGIN:
      return {
        ...state,
        fetchAlertsPending: true,
        fetchAlertsError: null,
        alerts: []
      };

    case FETCH_ALERTS_SUCCESS:
      return {
        ...state,
        fetchAlertsPending: false,
        fetchAlertsError: null,
        alerts: action.data
      };

    case FETCH_ALERTS_FAILURE:
      return {
        ...state,
        fetchAlertsPending: false,
        fetchAlertsError: action.data.error,
      };

    case FETCH_ALERTS_DISMISS_ERROR:
      return {
        ...state,
        fetchAlertsError: null,
      };

    default:
      return state;
  }
}
